import React from 'react'
import ContainerLayout from '../../../../components/layout/ContainerLayout'
import {useImage} from '../../../../utils/image'
import useNavigation from '../../../../hooks/useNavigation'
import WizImage from '../../../../components/image/WizImage'
import Text from '../../../../components/text/Text'
import WizButton from '../../../../components/button/WizButton'
import {ICopierDetail} from '../../../../apis/copier/copierDetail'
import {useTime} from '../../../../utils/time'

interface IProps {
    className?: string
    data?: ICopierDetail
}

const CopierInfoContainer: React.FC<IProps> = ({className, data}) => {
    const {renderThumbnail} = useImage()
    const {goUserDetail, goLeaderDetail} = useNavigation()
    const {localTimeString} = useTime()

    return (
        <div className={'grid grid-cols-2 gap-[30px] lg:gap-[20px] md:block md:space-y-[15px]'}>
            <ContainerLayout>
                <div className={'flex space-x-[10px] items-center sm:flex-col sm:space-x-[0px] sm:gap-y-[10px]'}>
                    <div className={'flex-none relative'}>
                        <WizImage
                            src={renderThumbnail(data?.user_thumbnail)}
                            className={`w-[60px] h-[60px] rounded-full lg:w-[40px] lg:h-[40px] ${
                                (data?.pause_at || data?.deleted_at) && 'border-[2px] border-font_red'
                            }`}
                        />
                        {(data?.pause_at || data?.deleted_at) && (
                            <div
                                className={`absolute bg-tag_red_light py-[1px] px-[3px] rounded-[5px] top-[-5px] lg:top-[-10px] left-[50%] translate-x-[-50%] border-[2px] border-font_red`}>
                                <Text className={'text-font_red text-ti4'}>
                                    {data?.deleted_at ? 'Delete' : 'Pause'}
                                </Text>
                            </div>
                        )}
                    </div>
                    <div className={'flex-1 truncate'}>
                        <div className={'flex items-center space-x-[7px] sm:justify-center truncate'}>
                            <Text
                                className={`text-h3 lg:text-ti1 truncate ${
                                    (data?.pause_at || data?.deleted_at) && 'text-font_red'
                                }`}>
                                {data?.user_name}
                            </Text>
                            <Text className={'text-ti3 text-font03 truncate'}>{data?.status}</Text>
                        </div>
                        <Text className={'text-body3 text-font03 truncate'}>Bot Name : {data?.name || '-'}</Text>
                        <Text className={'text-body3 text-font03 truncate'}>
                            Create At : {data?.start_at ? localTimeString(data?.start_at) : '-'}
                        </Text>
                        {data?.pause_at && (
                            <Text className={'text-body3 text-font_red truncate'}>
                                Pause At : {new Date(data?.pause_at).toLocaleString()}
                            </Text>
                        )}
                        {data?.deleted_at && (
                            <Text className={'text-body3 text-font_red truncate'}>
                                Delete At : {new Date(data?.deleted_at).toLocaleString()}
                            </Text>
                        )}
                    </div>
                    <div className={'flex space-x-[10px]'}>
                        <WizButton
                            text={'Portfolio'}
                            type={'primary'}
                            onClick={() => window.open(`https://leagueoftraders.io/ko/user/${data?.user_id}/portfolio`)}
                        />
                        <WizButton text={'User Detail'} type={'blue'} onClick={() => goUserDetail(data?.user_id)} />
                    </div>
                </div>
            </ContainerLayout>

            <ContainerLayout>
                <div className={'flex space-x-[10px] items-center sm:flex-col sm:space-x-[0px] sm:gap-y-[10px]'}>
                    <div>
                        <WizImage
                            src={renderThumbnail(data?.leader_thumbnail)}
                            className={'w-[60px] h-[60px] rounded-full lg:w-[40px] lg:h-[40px]'}
                        />
                    </div>
                    <div className={'flex-1 cursor-pointer'} onClick={() => goLeaderDetail(data?.leader_key_id)}>
                        <div className={'flex items-center space-x-[7px] sm:justify-center'}>
                            <Text className={'text-h3 lg:text-ti1'}>{data?.leader_name || '-'}</Text>
                        </div>
                        <Text className={'text-body3 text-font03'}>Exchange : {data?.leader_exchange || '-'}</Text>
                        <Text className={'text-body3 text-font03 truncate'}>
                            Leader Key : {data?.leader_key_id || '-'}
                        </Text>
                    </div>
                    <div className={'flex space-x-[10px]'}>
                        <WizButton
                            text={'Leaderfolio'}
                            type={'leader'}
                            onClick={() =>
                                window.open(`https://leagueoftraders.io/ko/key/${data?.leader_key_id}/portfolio`)
                            }
                        />
                        <WizButton text={'User Detail'} type={'blue'} onClick={() => goUserDetail(data?.leader_id)} />
                    </div>
                </div>
            </ContainerLayout>
        </div>
    )
}

export default CopierInfoContainer
